import { FBFirestoreRef } from '@/helpers/firebaseServices';

export function FSGetUserEvent(eventId) {
  return FBFirestoreRef
    .collection('events')
    .doc(eventId);
}

export function FSGetUserEvents(userId) {
  return FBFirestoreRef
    .collection('events')
    .where('team', 'array-contains', userId);
}

export function FSGetUserTeamMembers(userId) {
  return FBFirestoreRef
    .collection('users')
    .doc(userId)
    .collection('teamMembers');
}

export function FSGetEventGuests(eventId) {
  return FBFirestoreRef
    .collection('events')
    .doc(eventId)
    .collection('guests');
}

export function FSGetEventGuest(eventId, guestId) {
  return FBFirestoreRef
    .collection('events')
    .doc(eventId)
    .collection('guests')
    .doc(guestId);
}

export function FSGetEventMember(eventId, userId) {
  return FBFirestoreRef
    .collection('events')
    .doc(eventId)
    .collection('members')
    .doc(userId);
}
